import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './TableOfContents.scss';

export interface IParagraphHeading {
    field_heading: string;
    field_numbering: string;
    field_subtitle: string;
    type: string;
}
interface ITableOfContentsProps {
    headers: IParagraphHeading[];
}

export const TableOfContents = ({ headers }: ITableOfContentsProps) => {
    if (!headers.length) return;
    return (
        <div className="table-of-contents">
            <p>In this article:</p>
            <ul>
                {headers.map((item) => (
                    <li key={item.field_heading}>
                        <SmartLink
                            url={`#${encodeURIComponent(item.field_heading)}`}
                        >
                            {`${item.field_numbering ?? ``} 
                        ${item.field_heading}`}
                        </SmartLink>
                    </li>
                ))}
            </ul>
        </div>
    );
};
